import React from 'react';

import SimpleSearchSelect from '../../Forms/Input/SimpleSearchSelect';

import { ProductFormValues } from '../../../types/product/ProductFormValues';
import { useProduct } from '../../../hooks/useProduct';

interface Props {
  form: ProductFormValues;

  brandOptions?: any[];

  categoryOptions?: any[];

  subCategoryOptions?: any[];

  loadSubCategoriesByCategory: (categoryId: number) => void;

  onChange: (field: keyof ProductFormValues, value: any) => void;
}

const ProductCommercialClassificationSection: React.FC<Props> = ({
  form,
  brandOptions = [],
  categoryOptions = [],
  subCategoryOptions = [],
  loadSubCategoriesByCategory,
  onChange,
}) => {
  const { formErrors } = useProduct();

  return (
    <div className="grid grid-cols-1 gap-6 md:grid-cols-3">
      {/* Marca */}
      <SimpleSearchSelect
        label="Marca"
        name="brand"
        iconKey="search"
        options={brandOptions}
        selectedValue={form.brandId ?? 0}
        onSelect={(brand) => onChange('brandId', brand.id)}
      />

      {/* Categoría */}
      <SimpleSearchSelect
        label="Categoría"
        name="category"
        dataField="categoryId"
        iconKey="search"
        options={categoryOptions}
        selectedValue={form.categoryId ?? 0}
        required
        onSelect={(category) => {
          onChange('categoryId', category.id);

          // Limpiar subcategoría anterior
          onChange('subCategoryId', null);

          loadSubCategoriesByCategory(category.id);
        }}
        error={formErrors.categoryId}
      />

      {/* Subcategoría */}
      <SimpleSearchSelect
        label="Subcategoría"
        name="subCategory"
        iconKey="search"
        options={subCategoryOptions}
        selectedValue={form.subCategoryId ?? 0}
        disabled={!form.categoryId}
        onSelect={(subCategory) => onChange('subCategoryId', subCategory.id)}
      />
    </div>
  );
};

export default ProductCommercialClassificationSection;
